import React, { useEffect, useState } from "react";
import { getAnnouncements } from "services/announcements";
import { getEvents } from "services/events";
import { getDocuments } from "services/documents";
import Announcements from "./components/Announcements";

const Dashboard = () => {
  const [counts, setCounts] = useState({
    announcements: 0,
    events: 0,
    documents: 0,
  });
  const [recentEvents, setRecentEvents] = useState<any[]>([]);

  useEffect(() => {
    const load = async () => {
      try {
        const [a, e, d] = await Promise.all([
          getAnnouncements(),
          getEvents(),
          getDocuments(),
        ]);
        const aList = Array.isArray(a?.data?.data) ? a.data.data : [];
        const eList = Array.isArray(e?.data?.data) ? e.data?.data : [];
        const dList = Array.isArray(d?.data?.data) ? d.data.data : [];
        setCounts({
          announcements: aList.length,
          events: eList.length,
          documents: dList.length,
        });
        setRecentEvents(eList.slice(0, 5));
      } catch (err) {
        console.error(err);
      }
    };
    load();
  }, []);

  return (
    <div>
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-3 lg:grid-cols-3">
        <div className="rounded-lg bg-white p-4 shadow dark:bg-navy-700 dark:shadow-none">
          <h4 className="text-sm font-semibold dark:text-white">
            Announcements
          </h4>
          <p className="text-2xl font-bold">{counts.announcements}</p>
        </div>
        <div className="rounded-lg bg-white p-4 shadow dark:bg-navy-700 dark:shadow-none">
          <h4 className="text-sm font-semibold dark:text-white">
            Upcoming Events
          </h4>
          <p className="text-2xl font-bold">{counts.events}</p>
        </div>
        <div className="rounded-lg bg-white p-4 shadow dark:bg-navy-700 dark:shadow-none">
          <h4 className="text-sm font-semibold dark:text-white">Documents</h4>
          <p className="text-2xl font-bold">{counts.documents}</p>
        </div>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 lg:grid-cols-3">
        <div className="col-span-2">
          <Announcements />
        </div>
        <div className="">
          <div className="mb-4 rounded-lg bg-white p-4 shadow dark:bg-navy-700 dark:shadow-none">
            <h4 className="text-lg font-semibold dark:text-white">
              Upcoming Events
            </h4>
            {recentEvents.length === 0 ? (
              <p className="text-gray-500">No upcoming events</p>
            ) : (
              <ul className="mt-2 space-y-2">
                {recentEvents.map((ev) => (
                  <li key={ev.id} className="text-sm">
                    <div className="font-medium">{ev.name}</div>
                    <div className="text-xs text-gray-600">{ev.event_date}</div>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="rounded-lg bg-white p-4 shadow dark:bg-navy-700 dark:shadow-none">
            <h4 className="text-lg font-semibold dark:text-white">
              Recent Documents
            </h4>
            <p className="text-sm text-gray-500">
              Manage documents in Documents → Admin
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
